export default __webpack_public_path__ + "static/media/ProductSans-Thin.7fff1ad7.woff2";